<script lang="ts">
	import PageHeader from '$lib/components/page-header.svelte';
	import Tags from '$lib/components/tags.svelte';
	import Posts from '$lib/components/posts.svelte';
	import { siteBaseUrl, appName } from '$lib/meta';
	import type { PageData } from './$types';

	export let data: PageData;
	export const { tags, posts } = data;
</script>

<svelte:head>
	<title>Home | {appName}</title>
</svelte:head>

<section>
	<PageHeader>About BLOG.siposdani87</PageHeader>

	<h2>Practical guides for software engineers</h2>
	<p>
		Hi, I am <a href={siteBaseUrl} target="_blank" rel="noreferrer">D&aacute;niel Sipos</a>, a
		senior software engineer. This blog is a collection of practical solutions to real-world
		development challenges I have encountered over the years. From Docker optimizations and CI/CD
		pipelines to frontend frameworks and mobile development — each article provides working code and
		clear explanations. I hope you find something useful here.
	</p>

	<h3>Latest posts</h3>
	<Posts {posts} />

	<div class="flex pt-2 pb-5 justify-center">
		<a
			href="/posts"
			class="px-5 py-2 text-sm font-medium rounded-full bg-text text-surface hover:bg-primary transition-colors duration-200"
			>More posts</a
		>
	</div>

	<h2>Tag Cloud</h2>
	<Tags {tags} />
</section>

<style lang="postcss">
	@reference "../app.css";

	h2,
	h3 {
		@apply mt-3 mb-3;
	}
	p {
		@apply mb-5;
	}

	p a {
		@apply font-bold underline decoration-primary;
	}

	p a:hover {
		@apply text-primary;
	}
</style>
